"use client";

import TravelDates from "@/app/components/travel-dates";
import TravelDateProvider from "@/app/components/travel-dates/providers/travel-dates.provider";
import { TravelDatePageType } from "@/app/components/travel-dates/types/travel-dates.type";

function TravelDatesPage({ magnoliaData }: TravelDatePageType) {
  return (
    <TravelDateProvider initialValue={magnoliaData}>
      <TravelDates />
    </TravelDateProvider>
  );
}

export default TravelDatesPage;
